import { InjectionToken } from '@angular/core';
import { InterfaceAppConfig } from './app-interface.config';

export const APP_DI_CONFIG: InterfaceAppConfig = {
    apis: {
        submitGyan: {
            initiatesearch: 'rapid/gyan/create/gyan',
            savedraftgyan: 'draft/save',
            getdrafts: 'draft/get',
            deletedraft: 'draft/delete',
        },
        gyanSearch: {
            getgyanmultidocsummary: 'rapid/gyan/v1/mds',
            clickback: 'rapid/gyan/article/v1/article/clickback',
        },
        articles: {
            getArticleList: 'rapid/gyan/article/list',
            getArticleLongStory: 'rapid/gyan/article/highlighted-summary',
            getNetwrokGraph: 'rapid/gyan/v1/articlenetwork',
        },
        gyan: {
            azureTokenLogin: 'user/azure-token-login',
            logout: 'user/logout',
            autoLogin: 'user/auto-login',
            submitGyan: {
                getKnowledgeStore: 'gyan/create/v1/gyanknowledgestore',
                //initiateOldGyanSearch: 'gyan/create/v3/submitconceptfordiscovery',
                initiateOldGyanSearch: 'gyan/create/v4/submitconceptfordiscovery',
                templateGyans: 'ontology/ontocategoryhierarchy',
                getMDS: 'article/v2/topiclevelmultidocsummary',
                clickback: 'v2/article/getmentions',
                // indexedRepositories: 'task/getindexedrepositories',
                indexedRepositories: 'task/getindexedrepositories',
                getTag: 'task/gettags',
                repoTags: 'task/repo-tags',
                solrQuery: 'properties/query',
                getKnowledgeStoreTags: 'gyan/create/v1/gyanknowledgestore/tags',
                specialsources: 'master/data/specialsources',
                getSearchList: 'ontology/rapidgyanontology',
                getGyanTemplate: 'gyancard/v2/getGyanTemplate',
            },
            articles: {
                getArticleList: 'v2/article/getbooknodesummary',
                // getArticleDetails: 'v2/article/getarticlesummary',
                getArticleLongStory: 'article/gethighlightedsummary',
                getNetwrokGraph: 'gyannetwork/v1/genericarticlenetwork',
            },
            gyanStatus: {
                getGyanStatus: 'gyan/create/v1/gyanstatus',
            },
            organisation: {
                topicDetails: 'topic/v3/getmytopicdetails',
                searchtopicbyname: 'topic/v2/searchtopicbyname',
                createfolderbyname: 'folder/create',
                fetchFoldersList: 'folder/subfolder',
                movemultiplegyan: 'folder/movegyanstofolder',
                editFolderName: 'folder/rename',
                editTopicName: 'home/addupdatealiasname',
                deleteFolder: 'folder/delete',
            },
            topicHierarchy: 'topic/gettopichierarchy',
            articleGyan: {
                topiclevelconfig: 'topic/v1/topicrules',
                bookNodeSummary: 'v2/article/getbooknodesummary',
                topiclevelmultidocsummary: 'article/v2/topiclevelmultidocsummary',
                topiclevelgpt3summary: 'gpt/v1/gptfortopic',
                getUserDocImages: 'document/attachments/v1/images',
                getImageFromUrl: 'document/attachments/v1/download',
            },
        },
        auth: {
            ssoResponse: 'rapid/gyan/auth/sso-response',
            signUp: 'rapid/gyan/auth/sign-up',
            verifyUser: 'rapid/gyan/auth/verify-user',
            isEmailExists: 'rapid/gyan/auth/is-email-exists',
            guestSignUp: 'rapid/gyan/auth/guest-sign-up',
        },
        previousSearch: {
            getPreviousList: 'rapid/gyan/previous/gyan',
            deleteGyan: 'rapid/gyan/delete/gyan?personId=',
            renameGyan: 'rapid/gyan/rename/gyan',
        },
        advaceQuerySearch: {
            getAdvanceQueryList: 'topic/v3/getmytopicdetails',
            notifytoupprewarmingaci: 'gyan/create/v1/notifytoupprewarmingaci',
            deleteTopic: 'rapid/gyan/delete/gyan?personId=',
            deleteGyan: 'gyan/dashboard/gyancard/v2/deleteGyan?id=',
            renameAQ: 'rapid/gyan/rename/gyan',
            pushgyan: 'user/assigngyantoCWBuser',
        },
        admin: {
            accessList: 'admin/v1/access-list',
            clientList: 'admin/v1/client-list',
            createandUpdate: 'admin/v1/create-update-user-group',
            usergroupList: 'admin/v1/user-groups',
            userGroupType: 'admin/v1/user-group-type',
            createAccess: 'admin/v1/createaccess',
            updateAccess: 'admin/v1/updateaccess',
            listofAccess: 'admin/v1/getlistofaccess',
            siteVisibility: 'admin/v1/mks/site-visibility',
            createAndUpdateSite: 'admin/v1/mks/create-update-site',
            usergroupListMKS: 'admin/v1/mks/user-groups',
            siteRole: 'admin/v1/mks/site-roles',
            listofgks: 'admin/v1/getgyanknowledgestore',
            createnewgks: 'admin/v1/creategks',
            updategks: 'admin/v1/updategks',
        },
    },
};

export const APP_CONFIG = new InjectionToken<InterfaceAppConfig>('app.config');
